import styled from "styled-components"
//import breakpoint from 'styled-components-breakpoint'
import tw from "twin.macro"

const Style = styled.div.attrs((props) => ({
  className: "page",
}))`
  margin-left: auto;
  margin-right: auto;
  margin-top: 8vmin;
  margin-bottom: 8vmin;
  display: flex;
  flex-direction: column;

  ${tw`
        [paddingLeft:7vmin]
        [paddingRight:7vmin]
        lg:px-0
        [maxWidth:1280px]
        xmg:[maxWidth:calc(1760px * 0.75)]
        md:grid
        md:gap-x-10
        xl:gap-x-16
        md:[gridTemplateAreas: "sidebar" "main"]
        gap-y-8
        md:gap-y-0
        [gridTemplateColumns:minmax(260px, 1fr) 3fr]
        [gridTemplateRows:auto]
    `}

  > * {
    ${tw`md:[gridRow:1/2] md:[gridColumn:1/3]`}
  }

  article,
  section,
  .prose {
    order: 1;
    margin-left: auto;
    margin-right: auto;

    h1 {
      font-weight: 600;
      font-size: calc(1.45vmax + 1.15em);
      text-align: center;
      line-height: 1.3;
    }
  }

  aside + article,
  aside + section,
  aside + .prose {
    max-width: inherit;
    ${tw`md:[gridColumn:2/3] w-full`}

    h1 {
      text-align: left;
    }
  }

  .prose h3 {
    ${tw`text-xl lg:text-2xl`}

    & + * {
      ${tw` [marginTop:1em]`}
    }
  }

  aside {
    order: 2;

    ${tw`md:[gridColumn:1/2] md:overflow-hidden`}

    .sticky {
      position: sticky;
      top: 0;
    }

    .btn--pill {
      max-width: 100%;
      display: inline-flex;

      svg {
        vertical-align: middle;
        margin-right: 0.25em;
      }
    }

    a {
      ${tw`outline-none`}
      &:hover .btn--pill {
        ${tw`bg-gray-600`}
      }
      &:focus-visible .btn--pill {
        ${tw`bg-orange`}
      }
    }
  }

  aside dl {
    margin-bottom: 0;
    ${tw`mb-0`}

    > dt {
      letter-spacing: 0.04em;
      ${tw`font-semibold uppercase`}

      + dd {
        margin-top: 1.5em;
        margin-bottom: 0;
      }

      ~ dt {
        margin-top: 2em;
      }
    }

    ul {
      ${tw`list-none m-0 flex flex-wrap md:flex-col gap-2`}

      > li {
        margin: 0;
      }

      .btn--pill {
        ${tw`truncate rounded-3xl overflow-hidden py-2 h-auto min-h-full leading-none! px-4 text-sm inline-flex items-center justify-center`}
      }
    }
  }

  aside * + dl {
    margin-top: 2em;
  }
`

export default Style
